import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareAccessMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  expiration?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  access?: Types.InputMaybe<Types.ShareAccessInput>;
  generatePassphrase: Types.Scalars['Boolean']['input'];
}>;


export type UpdateShareAccessMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, access?: Types.ShareAccess | null, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, passphrase?: string | null, isGeneratedPassphrase?: boolean | null } | { __typename?: 'CollectionShare', id: string, access?: Types.ShareAccess | null, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, passphrase?: string | null, isGeneratedPassphrase?: boolean | null } | null, metadata?: { __typename?: 'UpdateShareMetadata', passphraseGenerated: boolean } | null } | null };


export const UpdateShareAccess = /*#__PURE__*/ gql`
    mutation UpdateShareAccess($shareId: ID!, $enabled: Boolean, $expiration: DateTime, $access: ShareAccessInput, $generatePassphrase: Boolean!) {
  updateShare(
    input: {shareId: $shareId, settings: {enabled: $enabled, expiration: $expiration, access: $access, generatePassphrase: $generatePassphrase}}
  ) {
    share {
      id
      access
      enabled
      expiration
      expiresIn
      name
      passphrase @include(if: $generatePassphrase)
      isGeneratedPassphrase @client @include(if: $generatePassphrase)
    }
    metadata @include(if: $generatePassphrase) {
      passphraseGenerated
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareAccessMutation, UpdateShareAccessMutationVariables>;

          

          export const useUpdateShareAccessMutation = (options?:MutationHookOptions<UpdateShareAccessMutation, UpdateShareAccessMutationVariables>) => useMutation(UpdateShareAccess, options);
          

          export type UpdateShareAccessMutationOptions = MutationHookOptions<UpdateShareAccessMutation, UpdateShareAccessMutationVariables>;

          

          export type UpdateShareAccessMutationResult = ReturnType<typeof useUpdateShareAccessMutation>[1];

          
